import React, { useState, useEffect } from "react";
import "./ReportTableRow.css";
import {
  upsertSencoReport,
  getSencoReportByStudentId,
  getStudentClassDetail,
  updateStudent,
  getNotes,
} from "../services/APIClient";
import SENWatchlistTable from "./SENWatchlistTable";
import Tooltip from "./Tooltip";
import { Modal, Button } from "react-bootstrap";
import SenWatchlistModal from "./SenWatchlistModal";


function SENWatchlistTableRow({
  student,
  dummyHeaderArray,
  getReadingScoreClass,
  handleShowLiteracyModal,
  handleShowAdditionalNeedsModal,
  handleShowSencoAdditionalNeedsModal,
  handleShowDetailsOfSetReceivedModal,
  handleShowPriorityConcernsModal,
  handleShowSencoSupportPlanModal,
  handleShowPlaceOnContinuumModal,
  handleShowClassroomSupportPlanModal,
  handleShowSencoEalModal,
  handleShowSetSetNameModal,
  handleShowSetModal,
  handleShowAttendanceAffectingScoresModal,
  teachers,
  teacherid,
  readingScores,
  dataVersion,
}) {
  const [literacyObservations, setLiteracyObservations] = useState("");
  const [additionalNeeds, setAdditionalNeeds] = useState([]);
  const [supportPlan, setSupportPlan] = useState([]);
  const [eal, setEal] = useState(false);
  const [set, setSet] = useState(false);
  const [studentSenState, setStudentSenState] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [isWatchlistChecked, setIsWatchlistChecked] = useState(true);

  const [attendanceAffectingScores, setAttendanceAffectingScores] =
    useState(false);
  const [setReceived, setSetReceived] = useState([]);
  const [priorityConcerns, setPriorityConcerns] = useState([]);
  const [sencoSupportPlan, setSencoSupportPlan] = useState([]);
  const [placeOnContinuum, setPlaceOnContinuum] = useState([]);
  const [classroomSupportPlan, setClassroomSupportPlan] = useState(false);
  const [sencoAdditionalNeeds, setSencoAdditionalNeeds] = useState([]);
  const [sencoEal, setSencoEal] = useState(false);
  const [callClassName, setCallClassName] = useState("");
  const [setName, setSetName] = useState("");
  const [currentStudentId, setCurrentStudentId] = useState("");

  const [literacyButtonClicked, setLiteracyButtonClicked] = useState(false);
  const [additionalNeedsButtonClicked, setAdditionalNeedsButtonClicked] =
    useState(false);
  const [
    detailsOfSetReceivedButtonClicked,
    setDetailsOfSetReceivedButtonClicked,
  ] = useState(false);
  const [priorityConcernsButtonClicked, setPriorityConcernsButtonClicked] =
    useState(false);
  const [sencoSupportPlanButtonClicked, setSencoSupportPlanButtonClicked] =
    useState(false);
  const [classroomSupportPlanModalClicked, setClassroomSupportPlanClicked] =
    useState(false);
  const [placeOnContinuumButtonClicked, setPlaceOnContinuumButtonClicked] =
    useState(false);
  const [ealModalButtonClicked, setEalModalButtonClicked] = useState(false);
  const [setModalButtonClicked, setSetModalButtonClicked] = useState(false);
  const [attendanceModalButtonClicked, setAttendanceModalButtonClicked] =
    useState(false);
  const [watchlistNotesClicked, setWatchlistNotesClicked] = useState(false);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showWatchlistModal, setShowWatchlistModal] = useState(false);
  const [watchlistModalAction, setWatchlistModalAction] = useState(null);
  const [watchlistNotesCount, setWatchlistNotesCount] = useState(0);

  const handleCheckboxClick = (student) => {
    setSelectedStudent(student);
    setWatchlistModalAction("remove");
    setShowWatchlistModal(true);
  };

  const handleWatchlistNotesClick = (student) => {
    setSelectedStudent(student);
    setWatchlistModalAction("note");
    setShowWatchlistModal(true);
  };

  const handleWatchlistSuccess = () => {
    // Re-fetch notes count instead of full page reload
    getNotes('student', student.id, 'SenWatchlist')
      .then((response) => {
        setWatchlistNotesCount((response.data || []).length);
      })
      .catch(() => {});
  };

  const handleConfirmRemove = () => {
    if (selectedStudent) {
      const currentSenState =
        studentSenState[selectedStudent.id] !== undefined
          ? studentSenState[selectedStudent.id]
          : selectedStudent.sen;

      setIsWatchlistChecked((prev) => !prev);
      handleSenToggle(selectedStudent.id, currentSenState);
    }
    setShowConfirmationModal(false);
    setSelectedStudent(null);
  };

  const handleCancelRemove = () => {
    setShowConfirmationModal(false);
    setSelectedStudent(null);
  };

  console.log(readingScores, "Overall Standard Score vs Test");

  const filteredTeachers = teachers
    .filter(
      (teacher) =>
        teacher.additionalRoles?.includes("SENCO") ||
        teacher.additionalRoles?.includes("SET")
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    if (setName && currentStudentId) {
      const reportData = {
        studentid: currentStudentId,
        teacherid: teacherid,
        setname: setName,
      };

      console.log("Saving report data:", reportData);

      upsertSencoReport(reportData)
        .then((response) => {
          console.log("Upsert SENCO Report Success:", response);
        })
        .catch((error) => console.error("Error:", error));
    } else {
      if (!currentStudentId) {
        console.log("No student selected. Skipping save operation.");
      }
      if (!setName) {
        console.log("No set name provided. Skipping save operation.");
      }
    }
  }, [setName, currentStudentId, teacherid]);

  useEffect(() => {
    if (student.id) {
      // Existing SENCO report fetch
      getSencoReportByStudentId(student.id)
        .then((response) => {
          if (response) {
            student.dateCreated = response.dateCreated || student.dateCreated;
            setCallClassName(response.classname || "");
            setSetName(response.setname || "");
            setClassroomSupportPlan(response.classroomsupportplan || false);
            setSencoEal(response.eal || false);
            setSet(response.set || false);
            setPlaceOnContinuum(response.supportcontinuum || []);
            setSencoAdditionalNeeds(response.additionalneeds || []);
            setPriorityConcerns(response.priorityconcerns || []);
            setSetReceived(response.setreceived || []);
            setSencoSupportPlan(response.supportplan || []);
          } else {
            setSencoEal(student.esl || false);
          }
        })
        .catch((error) => {
          console.error("Error fetching SENCO report:", error);
          setSencoEal(student.esl || false);
        });

      // Fetch class details
      getStudentClassDetail(student.id)
        .then((classDetails) => {
          if (classDetails) {
            setCallClassName(classDetails.className || "");
          }
        })
        .catch((error) =>
          console.error("Error fetching class details:", error)
        );

      // Fetch watchlist notes count from generic notes system
      getNotes('student', student.id, 'SenWatchlist')
        .then((response) => {
          setWatchlistNotesCount((response.data || []).length);
        })
        .catch((error) => {
          console.error("Error fetching watchlist notes:", error);
          setWatchlistNotesCount(0);
        });
    }
  }, [student.id, student.esl, dataVersion]);

  const handleSenToggle = async (studentId, currentSenState) => {
    const updatedSenState = !currentSenState;

    try {
      await updateStudent(studentId, { sen: updatedSenState });

      setStudentSenState((prevState) => ({
        ...prevState,
        [studentId]: updatedSenState,
      }));
    } catch (error) {
      console.error("Error updating SEN state:", error);
    }
  };

  const handleEalToggle = async (studentId, currentEalValue) => {
    const newEalValue = !currentEalValue;
    setSencoEal(newEalValue);
    setEalModalButtonClicked(true);

    const reportData = {
      studentid: studentId,
      teacherid: teacherid,
      eal: newEalValue,
    };

    const studentUpdateData = {
      esl: newEalValue,
    };

    try {
      await upsertSencoReport(reportData);
      console.log("Upsert SENCO Report Success for EAL:", newEalValue);

      await updateStudent(studentId, studentUpdateData);
      console.log("Update Student Success for ESL:", newEalValue);
    } catch (error) {
      console.error("Error updating EAL/ESL state:", error);
      setSencoEal(currentEalValue);
    }
  };

  const getButtonStyle = (buttonClicked, dataExists) => {
    return buttonClicked || dataExists ? { backgroundColor: "#ffffcc" } : {};
  };

  const getCircularButtonStyle = (
    buttonClicked,
    dataExists,
    borderColor = "black"
  ) => {
    const size = "40px";
    return {
      borderRadius: "50%",
      width: size,
      height: size,
      minWidth: size,
      minHeight: size,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      margin: "auto",
      border: `2px solid ${borderColor}`,
      backgroundColor: "white",
    };
  };

  return (
    <>
      {isWatchlistChecked && (
        <tr
          key={student.id}
          className="table-row student-results-table-row"
          data-student-id={student.id}
        >
          <td>
            <input
              type="checkbox"
              checked={true} // Always checked since these are watchlist students
              onChange={() => handleCheckboxClick(student)}
            />
          </td>

          {/* Watchlist Notes - moved before student name */}
          <td className="centre-student-items">
            <img
              src={
                watchlistNotesCount > 0
                  ? "./assets/imgs/file-pen-outline.svg"
                  : "./assets/imgs/file-outline.svg"
              }
              alt="View Watchlist Notes"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleWatchlistNotesClick(student);
              }}
            />
          </td>

          <td className="centre-student-items align-left">{student.name}</td>

          {dummyHeaderArray.map((header, index) => (
            <td key={index} className="centre-student-items">
              {header === "Classroom Support Plan" ? (
                <img
                  src={
                    classroomSupportPlan === true
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowClassroomSupportPlanModal(
                      student.name,
                      student.id
                    );
                  }}
                />
              ) : header === "Class" ? (
                <p>{callClassName}</p>
              ) : header === "Watchlist Notes" ? (
                // Skip this header since we moved it outside the map
                null
              ) : header === "SET" ? (
                <div className="custom-select-wrapper">
                  <select
                    className="custom-select"
                    value={setName}
                    style={{ width: "100px" }}
                    onChange={(e) => {
                      setCurrentStudentId(student.id);
                      setSetName(e.target.value);
                    }}
                  >
                    <option value="">Select SET</option>
                    {filteredTeachers.map((teacher) => (
                      <option key={teacher.id} value={teacher.name}>
                        {teacher.name}
                      </option>
                    ))}
                  </select>
                </div>
              ) : header === "Details Of SET Received" ? (
                <img
                  src={
                    setReceived.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowDetailsOfSetReceivedModal(
                      student.name,
                      student.id
                    );
                  }}
                />
              ) : header === "Priority Concerns" ? (
                <img
                  src={
                    priorityConcerns.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowPriorityConcernsModal(student.name, student.id);
                  }}
                />
              ) : header === "Support Plan" ? (
                <img
                  src={
                    sencoSupportPlan.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowSencoSupportPlanModal(student.name, student.id);
                  }}
                />
              ) : header === "Additional Needs" ? (
                <img
                  src={
                    sencoAdditionalNeeds.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowSencoAdditionalNeedsModal(
                      student.name,
                      student.id
                    );
                  }}
                />
              ) : header === "EAL" ? (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={sencoEal}
                    onChange={() => {
                      handleEalToggle(student.id, sencoEal);
                    }}
                    style={{
                      appearance: "none",
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      border: "2px solid #2c7693",
                      backgroundColor: "white",
                      cursor: "pointer",
                    }}
                  />
                  {sencoEal && (
                    <img
                      src="./assets/imgs/greenTick.svg"
                      alt="Checked"
                      style={{ width: "15px", position: "absolute" }}
                    />
                  )}
                </label>
              ) : header === "Place on Continuum" ? (
                <img
                  src={
                    placeOnContinuum.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowPlaceOnContinuumModal(student.name, student.id);
                  }}
                />
              ) : (
                <button className="white-button">
                  <i className="bi bi-pencil-square"></i>
                </button>
              )}
            </td>
          ))}
        </tr>
      )}

      {showWatchlistModal && (
        <SenWatchlistModal
          show={showWatchlistModal}
          onHide={() => setShowWatchlistModal(false)}
          student={selectedStudent}
          action={watchlistModalAction}
          teacherid={teacherid}
          onSuccess={handleWatchlistSuccess}
          teachers={teachers || []}
        />
      )}
    </>
  );
}

export default SENWatchlistTableRow;